import React, { FC, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { Grid } from '@mui/material';
import LegalSuggestAdapter from '../FinalFormAdapters/LegalSuggestAdapter';
import { DadataInnResponse } from '../../structures/response/dadata/DadataInnResponse';
import MfButton from '../UI/Button/MfButton';
import { setAgentInn } from '../../api/user';
import useAccount from '../../hooks/useAccount';
import useClosableSnackbar from '../../hooks/useClosableSnackbar';
import { errorToString } from '../../helpers/Helper';
import MfAlert from '../UI/Alert/MfAlert';
import { DadataLegalType } from '../../enum/DadataLegalType';

interface Props {
  legalType: DadataLegalType;
}

const InnSuggestForm: FC<Props> = ({ legalType = DadataLegalType.LEGAL }) => {
  const { fetchAccountResponse, accountResponse } = useAccount();
  const { showSnackbar } = useClosableSnackbar();
  const [innResponse, setInnResponse] = useState<DadataInnResponse | null>(
    null
  );

  const submit = async () => {
    if (innResponse?.inn) {
      try {
        await setAgentInn(innResponse.inn);
        showSnackbar('ИНН сохранён');
        fetchAccountResponse();
      } catch (e) {
        showSnackbar(errorToString(e));
        console.log(e);
      }
    }
  };

  return (
    <div>
      <Form
        initialValues={{ name: accountResponse?.displayName }}
        onSubmit={submit}
        render={({ handleSubmit, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Field
                  name="name"
                  label="ИНН или название компании"
                  component={LegalSuggestAdapter}
                  onItemSelected={(v: DadataInnResponse) => {
                    setInnResponse(v);
                  }}
                  legalType={legalType}
                />
                {Boolean(innResponse) && (
                  <MfAlert severity="info" sx={{ mt: 2 }}>
                    <div>
                      Выбрана организация {innResponse?.name?.full_with_opf}
                    </div>
                    <div>ИНН {innResponse?.inn}</div>
                    <div>Адрес {innResponse?.address?.value}</div>
                  </MfAlert>
                )}
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'right' }}>
                <MfButton
                  disabled={submitting || pristine}
                  type="submit"
                  variant="contained"
                >
                  Сохранить данные организации
                </MfButton>
              </Grid>
            </Grid>
          </form>
        )}
      />
    </div>
  );
};

export default InnSuggestForm;
